import { Page } from '@website-builder/model/structure/page';
import { Header } from '@website-builder/model/structure/header/header';
import { Footer } from '@website-builder/model/structure/footer';
import { WebsiteConfiguration } from '@website-builder/model/domain/website/website-configuration';
import { getNormalizeEntityId } from '@website-builder/util/make-widget-id.utility';
import { BuilderHelpers } from '@website-builder/model/domain/website/builder-helpers';

export class Website {
  id = getNormalizeEntityId();
  name = '';
  pages = new Array<Page>();
  headers = new Array<Header>();
  footers = new Array<Footer>();
  config = new WebsiteConfiguration();
  type: 'agent' | 'client';

  static normalizeInPlace(website: Partial<Website>): Website {
    const pureWebsite = new Website();

    website.id = website.id ?? pureWebsite.id;
    website.name = website.name ?? pureWebsite.name;
    website.type = website.type ?? pureWebsite.type;
    website.pages = BuilderHelpers.mapArray(website.pages, page => Page.normalizeInPlace(page));
    website.headers = BuilderHelpers.mapArray(website.headers, header => Header.normalizeInPlace(header));
    website.footers = BuilderHelpers.mapArray(website.footers, footer => Footer.normalizeInPlace(footer));
    website.config = WebsiteConfiguration.normalize(website.config);

    return website as Website;
  }
}
